module.exports = __webpack_public_path__ + "static/img/turntable_checked.474f376.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/turntable_checked.png
// module id = Vtvw
// module chunks = 1